import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { useMessenger } from "@/app/hooks/use-messenger";
import { PORTAL_USER_TYPE } from "@/app/models";
import { usePortalUserStore } from "@/app/stores";
import { IS_WEB_VIEW, useWebViewAuth } from "@/shared/lib";
import { useAuthStore } from "@/shared/stores";

export const useSetPortalUser = () => {
  const setPortalUser = usePortalUserStore((state) => state.setPortalUser);
  const isLoggedIn = useAuthStore((state) => Boolean(state.token));
  const { isLoading: isWebViewLoading } = useWebViewAuth();

  const shouldEnableQuery = isLoggedIn && (!IS_WEB_VIEW || !isWebViewLoading);

  const portalUserQuery = useQuery({
    ...appQueriesStore.user,
    enabled: shouldEnableQuery,
    staleTime: Infinity,
  });

  const {
    actions: { initializeMessenger },
  } = useMessenger();

  const subscriptionVendor = portalUserQuery.data?.subscriptions[0]?.vendor;

  useEffect(() => {
    if (portalUserQuery.data) {
      setPortalUser(portalUserQuery.data);
      if (
        portalUserQuery.data.type !== PORTAL_USER_TYPE.ADMIN &&
        !IS_WEB_VIEW
      ) {
        initializeMessenger(portalUserQuery.data);
      }
    }
  }, [portalUserQuery, setPortalUser, subscriptionVendor, initializeMessenger]);

  return portalUserQuery;
};
